import { useTranslation } from '@msdk/common'
import {
  CustomActionButtonAspect,
  CustomActionIconAlign,
  CustomActionPositionToDivider,
  TooltipDefinition,
} from '@msdk/definitions'
import { ButtonAlternative, ButtonIcon, ButtonPrimary, ButtonSecondary, IconSelector, styled, Tooltip } from '@msdk/ui'
import React from 'react'

import { ActionVisualizationMode } from './action-visualization'
import { ActionMenuItem, ActionMenuText } from './ActionMenuItem'

const StyledButtonIcon = styled(ButtonIcon)`
  color: ${({ theme }) => theme.palette.primary.main};
`

interface Props {
  disabled: boolean
  onClick: (e: any) => void
  label: string
  testId: string
  icon: string
  visualizationMode: ActionVisualizationMode
  aspect?: CustomActionButtonAspect
  iconAlign?: CustomActionIconAlign
  alignLeft?: boolean
  positionToDivider?: CustomActionPositionToDivider
  tooltip?: TooltipDefinition
}

export function CheckButtonComponent(aspect: CustomActionButtonAspect) {
  return aspect === CustomActionButtonAspect.Alternative
    ? ButtonAlternative
    : aspect === CustomActionButtonAspect.Secondary
    ? ButtonSecondary
    : ButtonPrimary
}

export function ActionElement(props: Props) {
  const t = useTranslation()
  // const ButtonComponent =
  //   props.aspect === CustomActionButtonAspect.Alternative
  //     ? ButtonAlternative
  //     : props.aspect === CustomActionButtonAspect.Secondary
  //     ? ButtonSecondary
  //     : ButtonPrimary
  const ButtonComponent = props?.aspect ? CheckButtonComponent(props.aspect) : ButtonPrimary
  const startIcon =
    props.iconAlign === CustomActionIconAlign.Left && props.icon ? <IconSelector iconName={props.icon} /> : null
  const endIcon =
    props.iconAlign === CustomActionIconAlign.Right && props.icon ? <IconSelector iconName={props.icon} /> : null
  let tooltipText = props.tooltip ? t(props.tooltip.idml, props.tooltip.description) : null
  if (props.visualizationMode === 'SingleAction' && tooltipText && props.icon) {
    tooltipText = props.label + '\n' + tooltipText
  }
  return (
    <>
      {props.visualizationMode === 'SingleAction' && (
        <Tooltip title={props.disabled && tooltipText ? tooltipText : props.label} arrow>
          <span>
            <StyledButtonIcon onClick={props.onClick} disabled={props.disabled}>
              {props.icon && <IconSelector iconName={props.icon} />}
              {!props.icon && props.label}
            </StyledButtonIcon>
          </span>
        </Tooltip>
      )}
      {props.visualizationMode === 'Buttons' && (
        <Tooltip title={props.disabled && tooltipText ? tooltipText : null} arrow>
          <ButtonComponent
            disabled={props.disabled}
            onClick={props.onClick}
            data-test-id={props.testId}
            startIcon={startIcon}
            endIcon={endIcon}
            alignLeft={props.alignLeft}
          >
            {props.label}
          </ButtonComponent>
        </Tooltip>
      )}
      {props.visualizationMode === 'MenuItems' && (
        <Tooltip title={props.disabled && tooltipText ? tooltipText : null} arrow>
          <span>
            <ActionMenuItem
              onClick={props.onClick}
              disabled={props.disabled}
              data-test-id={props.testId}
              aspect={props.aspect}
            >
              {props.icon && <IconSelector iconName={props.icon} />}
              <ActionMenuText disabled={props.disabled} aspect={props.aspect}>
                {props.label}
              </ActionMenuText>
            </ActionMenuItem>
          </span>
        </Tooltip>
      )}
    </>
  )
}
